import { Component, OnInit } from '@angular/core';
import { contentTransition } from "../../../animations";

@Component({
  selector: 'app-quibbl-related',
  templateUrl: './quibbl-related.component.html',
  styleUrls: ['./quibbl-related.component.scss'],
  animations: [contentTransition()],
  host: {'[@routerTransition]': ''}
})
export class QuibblRelatedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/category/quibbl-inspector/quibbl-related/quibbl-related.component.ts